import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { getAllowedRoutes } from '../../utils/utils';
import { selectPerms } from '../core/auth/authSlice';

import { Routes } from './Routes';
import SupportFooter from './SupportFooter';

function Nav(props) {
  const theme = useTheme();
  const location = useLocation();
  const perms = useSelector(selectPerms);

  let managePerms = [];
  let readPerms = [];
  let allPerms = [];

  if (perms?.M) {
    managePerms = perms.M;
  }

  if (perms?.R) {
    readPerms = perms.R;
  }

  allPerms = [...new Set([...managePerms, ...readPerms])];
  const allowedRoutes =
    getAllowedRoutes(allPerms, Routes, perms?.RN) || [];

  const path = location?.pathname ?? '';
  const activeStyle = { color: theme.palette.secondary.main };
  let defaultStyle = { color: theme.palette.white.main };

  const { menu } = props;
  const isFullMenu = menu === 'fullMenu';

  /* Here to style Icon Menu*/
  const iconStyle = {
    display: 'inlineFlex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  /**
   * sets active class for the menu item
   * @param {*} p
   * @returns
   */
  const getActiveClass = p => {
    let ep = 'dashboard';
    if (path) {
      const arr = path.split('/aktivu/');
      if (arr.length > 1) {
        ep = arr[1];
      }
    }
    return p === ep ? activeStyle : defaultStyle;
  };

  /**
   * renders a single nav item
   * @param {*} r
   * @param {*} i
   * @returns
   */
  const renderItem = (r, i) => {
    const itemStyle = getActiveClass(r.path);
    return (
      <NavLink
        to={r.path}
        style={{ textDecoration: 'none', color: 'white' }}
        key={`single-${r.name}-${i}`}
      >
        <MenuItem>
          <ListItemIcon style={itemStyle}>{r.icon}</ListItemIcon>
          {isFullMenu && (
            <ListItemText style={itemStyle}>{r.name}</ListItemText>
          )}
        </MenuItem>
      </NavLink>
    );
  };

  /**
   * renders groups
   * @param {*} r
   * @param {*} i
   * @returns
   */
  const renderGroup = (r, i) => {
    return (
      <Box key={`group-title-${r.name}-${i}`}>
        <Box>
          {isFullMenu && (
            <Typography
              variant="subtitle"
              sx={{ m: 2, color: theme.palette.white.main }}
            >
              {r.name.toUpperCase()}
            </Typography>
          )}
          <Divider
            sx={{ backgroundColor: theme.palette.white.main }}
          />
        </Box>
        {r?.children.map((c, ci) => {
          const itemStyle = getActiveClass(c.path);
          return (
            <NavLink
              to={c.path}
              style={{
                textDecoration: 'none',
                color: theme.palette.white.main,
              }}
              key={`child-${c.name}-${ci}`}
            >
              {isFullMenu && (
                <MenuItem sx={{ ml: 2 }}>
                  <ListItemIcon style={itemStyle}>
                    {c.icon}
                  </ListItemIcon>
                  <ListItemText style={itemStyle}>
                    {c.name}
                  </ListItemText>
                </MenuItem>
              )}
              {!isFullMenu && (
                <ListItemIcon style={{ ...itemStyle, ...iconStyle }}>
                  {c.icon}
                </ListItemIcon>
              )}
            </NavLink>
          );
        })}
      </Box>
    );
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <MenuList>
        {allowedRoutes.map((r, i) => {
          return r?.type === 'item'
            ? renderItem(r, i)
            : renderGroup(r, i);
        })}
      </MenuList>
      {isFullMenu && <SupportFooter />}
    </Box>
  );
}

export default Nav;
